import React from "react";
import { Link } from "react-router-dom";
import LegalPageLayout from "./LegalPageLayout";
import C from "./legal.config";

export default function CookiePolicy() {
  return (
    <LegalPageLayout title="Cookies & Tracking" version={C.versions.cookies}>
      <p>
        This page explains what cookies and similar technologies LEAGUE
        HUB uses, why we use them, and how you can control them. It
        complements our <Link to="/legal/privacy" className="underline">Privacy Policy</Link>.
      </p>

      <h2 className="legal-h2">1. What we use</h2>
      <table className="text-[12px] w-full mt-2 border-collapse">
        <thead>
          <tr className="text-left text-white/50">
            <th className="py-1 pr-3">Category</th>
            <th className="py-1 pr-3">Purpose</th>
            <th className="py-1">Opt-in?</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-t border-white/10">
            <td className="py-1 pr-3"><strong>Strictly necessary</strong></td>
            <td className="py-1 pr-3">Sign-in session cookie, CSRF protection, theme preference, cookie-consent decision itself.</td>
            <td className="py-1">No — always on. Without these the site doesn't work.</td>
          </tr>
          <tr className="border-t border-white/10">
            <td className="py-1 pr-3"><strong>Analytics</strong></td>
            <td className="py-1 pr-3">Cloudflare Real User Monitoring (<code>/cdn-cgi/rum</code>) — measures page-load performance and error rates.</td>
            <td className="py-1">Yes — off by default.</td>
          </tr>
          <tr className="border-t border-white/10">
            <td className="py-1 pr-3"><strong>Marketing</strong></td>
            <td className="py-1 pr-3">Reserved category for future advertising or retargeting integrations. Currently <strong>unused</strong>.</td>
            <td className="py-1">Yes — would require explicit opt-in.</td>
          </tr>
        </tbody>
      </table>

      <h2 className="legal-h2">2. How to control them</h2>
      <p>
        On your first visit you'll see a banner offering "Necessary only",
        "Accept all", or "Manage preferences". Your choice is stored in
        the cookie <code>lh.cookie.consent.v1</code> (a strictly-necessary
        cookie). You can revisit your decision at any time by clicking
        the small "COOKIE PREFS" link in the footer.
      </p>
      <p>
        You can also clear cookies in your browser settings. Note that
        clearing the strictly-necessary cookies will sign you out and
        re-show the consent banner.
      </p>

      <h2 className="legal-h2">3. Third-party cookies</h2>
      <ul className="list-disc pl-5 space-y-1">
        <li><strong>Cloudflare</strong> — sets a security cookie (<code>__cf_bm</code>) to identify legitimate traffic. This is a security measure and falls under "strictly necessary".</li>
        <li><strong>Stripe</strong> — sets a session cookie on the Stripe Checkout domain when you initiate a payment. Governed by Stripe's privacy policy.</li>
        <li><strong>Google / Discord OAuth</strong> — sign-in is via redirect; no third-party cookies are set on leaguehub.co itself.</li>
      </ul>

      <h2 className="legal-h2">4. Do Not Track</h2>
      <p>
        We honour the DNT header by treating it as an analytics opt-out:
        if your browser sends "DNT: 1" we do not load Cloudflare RUM
        even if you previously enabled analytics. This goes beyond
        what is currently required by Canadian law.
      </p>

      <h2 className="legal-h2">5. Updates</h2>
      <p>
        If we add new tracking technologies we will update this page,
        bump the version, and re-prompt you for consent if the change
        is material.
      </p>

      <p className="text-white/45 text-xs">
        See also: <Link to="/legal/privacy" className="underline">Privacy Policy</Link>.
      </p>
    </LegalPageLayout>
  );
}
